import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import './styles/main.scss';

import ForecastInputPage from './pages/ForecastInputPage.tsx';
import PermissionsPage from './pages/Administration/PermissionsPage';
import EditRolePage from './pages/Administration/EditRolePage';
import RawDataExportPage from './pages/Administration/RawDataExportPage';

import GraduationPrognosisPage from './pages/Statistics/GraduationPrognosisPage';
import UnauthorizedPage from './pages/UnauthorizedPage';

import NotFoundPage from "./pages/NotFoundPage";
import ErrorPage from "./pages/ErrorPage";

import { User } from './lib/dataAccess/DataAccess';
import FractionalStatisticsPage from "./pages/Statistics/FractionalStatisticsPage";
import AggregatedTablePage from "./pages/Statistics/AggregatedTablePage";
import HistoryPage from "./pages/Statistics/HistoryPage";
import AdmissionExamStatisticsPage from "./pages/Statistics/AdmissionExamStatisticsPage";
import CourseResultStatisticsPage from "./pages/Statistics/CourseResultStatisticsPage";
class NavigationRoute extends React.Component {

  constructor(props) {
      super(props);

      this.state = { hasError: false };
  }

  componentDidCatch(error, errorInfo) {
      console.error({error, errorInfo});
      this.setState({hasError: true});
  }

  render() {
    return (
        <React.Fragment>
            { this.state.hasError ?
                <ErrorPage role={this.props.role} />
              : <div id="navContainer">
                  <Route exact={this.props.exact} path={this.props.path}>
                    {this.props.children}
                  </Route>
              </div>
            }
        </React.Fragment>
    )
  }
}

export default class ForecastRouter extends React.Component
{
    constructor(props) 
    {
        super(props)
        
        this.getRole = this.getRole.bind(this);

        const role = sessionStorage.getItem("role") || "USER"
        
        this.state = {
            error: null,
            isLoading: false,
            role: role
        }
    }

    componentDidMount() {
      this.getRole();
    }

    async getRole() {
      if(window.location.pathname == "/unauthorized") {
        return;
      }
      const role = await User.getRole();

      sessionStorage.setItem("role", role)
      
      this.setState({role})
    }

    render() {
        const { error, isLoading, role } = this.state
        
        return (
          <Router>
              <Switch>
                <NavigationRoute exact path="/">
                  <ForecastInputPage role={role}/>
                </NavigationRoute>
                <NavigationRoute exact path="/admin/permissions">
                  <PermissionsPage role={role}/>
                </NavigationRoute>
                <NavigationRoute path="/admin/role/:roleId/edit">
                  <EditRolePage role={role}/>
                </NavigationRoute>
                <NavigationRoute exact path="/admin/dataexport">
                  <RawDataExportPage role={role}/>
                </NavigationRoute>
                <NavigationRoute exact path="/stat/examen">
                  <GraduationPrognosisPage role={role}/>
                </NavigationRoute>
                <NavigationRoute exact path="/stat/fractional">
                  <FractionalStatisticsPage role={role}/>
                </NavigationRoute>
                <NavigationRoute exact path="/stat/agg/overview">
                  <AggregatedTablePage role={role}/>
                </NavigationRoute>
                <NavigationRoute exact path="/stat/history">
                  <HistoryPage role={role}/>
                </NavigationRoute>
                <NavigationRoute exact path="/stat/admission">
                  <AdmissionExamStatisticsPage role={role}/>
                </NavigationRoute>
                <NavigationRoute exact path="/stat/courseresult">
                  <CourseResultStatisticsPage role={role}/>
                </NavigationRoute>
                <NavigationRoute exact path="/unauthorized">
                  <UnauthorizedPage />
                </NavigationRoute>
                <NavigationRoute exact path="/error">
                  <ErrorPage  role={role}/>
                </NavigationRoute>
                <NavigationRoute>
                  <NotFoundPage role={role} />
                </NavigationRoute>
              </Switch>
          </Router>
        );
    }
}
/*export default function ForecastRouter() {

  return (
    <Router>
        <Switch>
          <Route exact path="/">
            <ForecastInputPage role={'ADMIN'}/>
          </Route>
          <Route exact path="/admin">
            <PermissionsPage role={'ADMIN'}/>
          </Route>
          <Route path="/admin/role/:roleId/edit">
            <EditRolePage role={'ADMIN'}/>
          </Route>
          <Route>
            <NotFoundPage role={'ADMIN'} />
          </Route>
        </Switch>
    </Router>
  );
}*/
